import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


class PreferredSupplierRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      percent: initialValues.percent || 70,
      supplier_ids: initialValues.supplier_ids || [],
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'preferred_supplier',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { percent, supplier_ids, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          value={supplier_ids}
          onChange={ids => this.setState({ supplier_ids: ids })}
          placeholder='Select at least one supplier...'
          mode='multiple'
          showSearch={true}
          include_all={false}
          include_any={false}
        />
        <InlineInputNumber
          label='Minimum Purchases'
          description='The percent of purchases that need to be made with these suppliers'
          displayFormat='percent'
          value={percent}
          onChange={value => this.setState({ percent: value })}
        />
      </RuleForm>
    );
  }
}

PreferredSupplierRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

PreferredSupplierRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default PreferredSupplierRule;
